<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Group"
            bc3="Update"
            path="role"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
          <div class="form-group breadcrumb-right">
            <div class="dropdown">
              <button
                class="btn-icon btn btn-primary btn-round btn-sm dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <CommandIcon />
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="app-todo.html"
                  ><i class="mr-1" data-feather="check-square"></i
                  ><span class="align-middle">Todo</span></a
                ><a class="dropdown-item" href="app-chat.html"
                  ><i class="mr-1" data-feather="message-square"></i
                  ><span class="align-middle">Chat</span></a
                ><a class="dropdown-item" href="app-email.html"
                  ><i class="mr-1" data-feather="mail"></i
                  ><span class="align-middle">Email</span></a
                ><a class="dropdown-item" href="app-calendar.html"
                  ><i class="mr-1" data-feather="calendar"></i
                  ><span class="align-middle">Calendar</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                type="text"
                                v-model="name"
                                readonly
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--<div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>User Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                size="sm"
                                class="mt-1"
                              >
                                <b-form-select-option
                                  v-for="(item, index) in types"
                                  :key="index"
                                  :value="item"
                                  >{{ item }}
                                </b-form-select-option>
                              </b-form-select>
                            </div>
                          </div>
                        </div>
                      </div>-->
                      <div class="col-12">
                        <div class="form-group row align-items-center">
                          <div class="col-sm-3 col-form-label ">
                            <label for="rate-icon">Change Default Status</label>
                          </div>
                          <div class="col-sm-9">
                            <input
                              class="custom-checkbox"
                              type="checkbox"
                              v-model="defaultStatus"
                              name="statusCheckbox"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-9 offset-sm-3 text-right mt-2 d-flex">
                      <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loading"
                      >
                        <Loader :loading="loading" :size="size"></Loader>
                        Submit
                      </button>
                      <button
                        type="button"
                        class="btn btn-gradient-secondary"
                        @click="Back()"
                      >
                        Back
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";

export default {
  components: {
    CommandIcon
  },
  mounted() {
    let rolesUpdateData = this.$store.getters.getByKey(
      "groupDefaultStatusUpdate"
    );
    if (rolesUpdateData) {
      this.index = rolesUpdateData.index;
      this.id = rolesUpdateData.row.id;
      this.name = rolesUpdateData.row.name;
      this.defaultStatus = rolesUpdateData.row.is_default;
    }
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      defaultStatus: "",
      isDefault: false,
      types: [1, 2, 3, 4],
      size: "10px",
      loading: false
    };
  },
  methods: {
    Back() {
      this.$router.push({ name: "role" });
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = new FormData();
          data.append("application", "android");
          data.append("applicationVersion", "1.33");
          data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          data.append("deviceDetail", "android s4 etc");
          data.append("latitude", "");
          data.append("longitude", "");
          data.append("id", this.id);
          //  data.append("name", this.name);
          let status = this.defaultStatus == true ? 1 : 0;
          data.append("isDefault", status);
          data.append("type", 3);
          this.makeRequest("post", "v1/change-role-default-status", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  this.$router.push({
                    name: "role",
                    params: { update: true }
                  });
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("groups");
                    if (storeData != null) {
                      if (typeof storeData.firstPageData != "undefined") {
                        if (
                          typeof storeData.firstPageData.data[this.index] !=
                          "undefined"
                        ) {
                          if (
                            storeData.firstPageData.data[this.index].id ==
                            this.id
                          ) {
                            storeData.firstPageData.data[
                              this.index
                            ] = responseData;
                            delete storeData.otherPageData;
                          }
                        }
                      }
                      if (typeof storeData.otherPageData != "undefined") {
                        if (
                          typeof storeData.otherPageData.data[this.index] !=
                          "undefined"
                        ) {
                          if (
                            storeData.otherPageData.data[this.index].id ==
                            this.id
                          ) {
                            storeData.otherPageData.data[
                              this.index
                            ] = responseData;
                          }
                        }
                      }
                      storeData.key = "groups";
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "role",
                      params: { update: true }
                    });
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

